export const MAIN_LOAD_TRUE = 'MAIN_LOAD_TRUE';
export const MAIN_LOAD_FALSE = 'MAIN_LOAD_FALSE';
export const SET_AUTH_USER = 'SET_AUTH_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const SUCCESS_STATUS = 'SUCCESS_STATUS';
export const OTP_SENT_SUCCESS = 'OTP_SENT_SUCCESS';
export const OTP_VALID_SUCCESS = 'OTP_VALID_SUCCESS';
export const OTP_VALID_FAILS = 'OTP_VALID_FAILS';
export const GET_CONSTITUTION_OF_FIRM = "GET_CONSTITUTION_OF_FIRM";
export const GET_CHANNEL_PARTNER = "GET_CHANNEL_PARTNER";
export const GET_PROJECTS = "GET_PROJECTS";
export const GET_CP_LEAD = "GET_CP_LEAD";
export const GET_CP_DASHBOARD = "GET_CP_DASHBOARD";
export const GET_CP_LEAD_SITE_VISIT = "GET_CP_LEAD_SITE_VISIT";
export const CREATE_VENDOR = 'CREATE_VENDOR';
export const GET_CP_LEAD_DETAIL = "GET_CP_LEAD_DETAIL";

export const GET_CALL_STATUS = "GET_CALL_STATUS";

export const GET_BD_USER = "GET_BD_USER";
export const GET_COUNTRY_CODE="GET_COUNTRY_CODE"

